import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {FormGroup} from "@angular/forms";

@Component({
    selector: "wbo-checkbox-column",
    templateUrl: "./checkbox-column.component.html",
    styleUrls: ["./checkbox-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => CheckboxColumnComponent), multi: true}
    ]
})
export class CheckboxColumnComponent extends AbstractColumnComponent {
    @Input() cellClassGetter: (this: void, formGroup: FormGroup, dataItem: any) => any;

    constructor(injector: Injector) {
        super(injector);
    }

    override get autoClickOnRowEdit(): boolean {
        return false;
    }
}
